import React, { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { TableInfo } from "../../data/interfaces/sharedmodels";
import {
    Accordion, AccordionSummary, AccordionDetails, Box, Avatar, List, ListItemButton,
    TextField, ListItemText, Typography, ListItemAvatar, Card, CardHeader, CardContent, InputAdornment, IconButton
} from "@mui/material";
import { TableChart as TableViewIcon, ExpandMore as ExpandMoreIcon, Clear } from '@mui/icons-material';
import { updateselectedtable as updatemagneticselectedtable } from "../../stores/magneticslice";
import { updateselectedtable as updateitsoselectedtable } from "../../stores/itsoslice";
import { IsEditedContext } from "../../../App";
import ConfirmDialog from "../confirmdialog";

export default function DataTables({ parent, tables }: { parent: string, tables: TableInfo[] }) {
    const dispatch = useAppDispatch();
    const [filterText,setFilterText]=useState<string>('');
    const [filteredTables, setFilteredTables] = useState<TableInfo[]>([]);

    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
    const [pendingTable, setPendingTable] = useState<TableInfo | null>(null);
    const { isEdited, setIsEdited } = useContext(IsEditedContext);
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const datatbaleExpanded = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.datatableExpanded; }
        else { return state.itsoReducer.datatableExpanded; }
    });
    const [expanded, setExpanded] = useState<string | false>('globaltables');

    
    useEffect(() => {
        setFilteredTables(tables);
        if (tables.length > 0) {
            if (parent === 'magnetic') {
                dispatch(updatemagneticselectedtable(tables[0]));
            }
            else {
                dispatch(updateitsoselectedtable(tables[0]));
            }

        }
    }, [tables])
    useEffect(()=>{
        let filtertables = [...tables]
        if(filterText)
            filtertables = [...tables].filter(a => a.Description.toLowerCase().includes(filterText.toLowerCase()));

        setFilteredTables(filtertables);
    },[filterText])
    // const handleListItemClick = (
    //     event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    //     table: TableInfo,
    // ) => {
    //     if (parent === 'magnetic') {
    //         dispatch(updatemagneticselectedtable(table));
    //     }
    //     else {
    //         dispatch(updateitsoselectedtable(table));
    //     }

    // };
    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, table: TableInfo) => {
        
        if (isEdited) {
           
          setConfirmDialogOpen(true); 
          setPendingTable(table); 
        } else {
          dispatch(parent === "magnetic" ? updatemagneticselectedtable(table) : updateitsoselectedtable(table));
        }
      };


      const handleDialogCallback = (confirmed: boolean) => {
        setConfirmDialogOpen(false);
       
        if (!confirmed && pendingTable) {
            setIsEdited(false);
          dispatch(parent === "magnetic" ? updatemagneticselectedtable(pendingTable) : updateitsoselectedtable(pendingTable));
        }
        setPendingTable(null); 
      };

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

    const onFilterChnage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setFilterText(event.target.value);
        
        

    };
    const clearFilter=()=>{
        setFilterText('');
    }
    return (
        <Card>
             
      <ConfirmDialog
        isopen={confirmDialogOpen}
        title="Unsaved Changes"
        message="Are you sure you want to continue? Any unsaved changes will be lost."
        needComments={false}
        callback={handleDialogCallback}
        yesButtonText="Stay and Save"
        cancelButtonText="Continue"
      />
            <CardHeader title={
                <Box>
                    <Box sx={{display:'flex',mb:1}}>
                    <Avatar sx={{ backgroundColor: 'primary.main' }}>
                                                        <TableViewIcon />
                                                    </Avatar>

                    <Typography variant="h6" sx={{ml:2}}>Datatables</Typography>                          
                    </Box>
                <TextField value={filterText} label="Filter Data Tables" size="small" onChange={onFilterChnage} sx={{ width: '100%' }} 
            InputProps={filterText?{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={clearFilter}>
                        <Clear />
                    </IconButton>
                    
                  </InputAdornment>
                ),
              }:undefined}/></Box>} />
            <CardContent sx={{ pt: 0 }}>

                <Box component="div">
                    {filteredTables.findIndex(a => a.IsGlobal)>-1 ?
                    <Accordion expanded={expanded === 'globaltables'||(filterText.trim().length>0&&filteredTables.filter(a => a.IsGlobal).length>0)} onChange={handleChange('globaltables')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="globaltables-content"
                            id="globaltables-header"
                        >
                            <Typography variant="h6">Global Tables</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            <List dense={true} >
                                {
                                    filteredTables.filter(a => a.IsGlobal).map(function (table) {
                                        return (
                                            <ListItemButton key={table.Id} selected={selectedTable?.Id === table.Id}
                                                onClick={(event) => handleListItemClick(event, table)}>
                                               
                                                <ListItemText primary={table.Description}  />
                                            </ListItemButton>)
                                    })
                                }
                            </List>
                        </AccordionDetails>
                    </Accordion>:null}
                    {filteredTables.findIndex(a => !a.IsGlobal)>-1?
                    <Accordion expanded={expanded === 'stationtables'||(filterText.trim().length>0&&filteredTables.filter(a => !a.IsGlobal).length>0)} onChange={handleChange('stationtables')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="stationtables-content"
                            id="stationtables-header"
                        >
                            <Typography variant="h6">Station Specific Tables</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            <List dense={true} >
                                {
                                    filteredTables.filter(a => !a.IsGlobal).map(function (table) {
                                        return (
                                            <ListItemButton key={table.Id} selected={selectedTable?.Id === table.Id}
                                                onClick={(event) => handleListItemClick(event, table)}>
                                                
                                                <ListItemText primary={table.Description}  />
                                               
                                            </ListItemButton>)
                                    })
                                }
                            </List>
                        </AccordionDetails>
                    </Accordion>:null}
                </Box>
            </CardContent>
        </Card>
    );
}